import axios from 'axios'
// 响应拦截器
axios.interceptors.request.use((config) => {
  config.withCredentials = true
  config.headers.token = sessionStorage.getItem('token')
  return config
}, (error) => {
  return Promise.reject(error)
})
axios.interceptors.response.use(response=>{
  return response.data
  // if(response.data.code===30001){
  //   Toast('请登录')
  // } else if (response.data.code === 30015){
  //   Toast(response.data.msg+',请重新登录')
  //   return Promise.reject(error)
  // }else if(response.data.code===200){
  //   return response.data
  // } else {
  //   Toast(response.data.msg)
  // }
},error=>{
  return Promise.reject(error)
})
export default axios
